import React,{Component} from 'react';
import ListSubheader from 'material-ui/List/ListSubheader';
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import { getJSON } from 'jquery'

class Classfy extends Component{

    handleClick(key,event){

        getJSON('http://123.207.90.121:8080/newBlog/api/getBlogsByType',{type:key}).then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.props.handleBlogArray(data);
                console.log("加载typeBlog成功"+data.length)
            }else {
                this.props.handleBlogArray([]);
                console.log("加载typeBlog失败")
            }
            this.setState({load:false})
        },error=> {
            this.setState({load:false})
        })

    }

    render(){


        return (
            <Paper style={{background: 'white'}}>
                <Divider />
                <List  component="nav"  subheader={<ListSubheader  component="div">Classfy</ListSubheader>}>
                    <ListItem  button onClick={this.handleClick.bind(this,'java')}>
                        <ListItemIcon>
                            <i className="material-icons">description</i>
                        </ListItemIcon>
                        <ListItemText primary="JAVA" />
                    </ListItem>
                    <ListItem button onClick={this.handleClick.bind(this,'js')}>
                        <ListItemIcon>
                            <i className="material-icons">card_travel</i>
                        </ListItemIcon>
                        <ListItemText primary="JAVASCRIPT" />
                    </ListItem>
                    <ListItem button onClick={this.handleClick.bind(this,'sql')}>
                        <ListItemIcon>
                            <i className="material-icons">dashboard</i>
                        </ListItemIcon>
                        <ListItemText primary="SQL" />
                    </ListItem>
                </List>
                <Divider />
                <List component="nav">
                    <ListItem button onClick={this.handleClick.bind(this,'else')}>
                        <ListItemIcon>
                            <i className="material-icons">account_balance</i>
                        </ListItemIcon>
                        <ListItemText primary="ELSE" />
                    </ListItem>

                    <ListItem   button component="a" onClick={this.handleClick.bind(this,'life')}>
                        <ListItemIcon>
                            <i className="material-icons">account_box</i>
                        </ListItemIcon>
                        <ListItemText primary="LIFE" />
                    </ListItem>
                </List>

            </Paper>
        )
    }

}
export default Classfy;


// WEBPACK FOOTER //
// ./src/Compent/page/Classfy.js